







































import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { BaseButton, BaseInput, BaseLoader } from '@shared/ui';
import { useForgotPassword } from '@unified-commerce/gpc-vue-storefront-shopify';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { email, required } from 'vee-validate/dist/rules';

extend('email', {
  ...email,
  message: 'Invalid email',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

export default defineComponent({
  name: 'ForgotPasswordForm',
  components: {
    ValidationProvider,
    ValidationObserver,
    BaseInput,
    BaseButton,
    BaseLoader,
  },
  setup() {
    const {
      request: requestForgotPassword,
      loading: forgotPasswordLoading,
      result: forgotPasswordResult,
      error: forgotPasswordError,
    } = useForgotPassword();

    const isForgotPasswordError = ref(false);
    const errorMessage = ref('');
    const successMessage = ref('');

    const forgotPasswordErrorMessage = computed(() => forgotPasswordError.value?.request?.message);

    const email = ref('');

    const handleForgotPassword = async () => {
      await requestForgotPassword({
        email: email.value,
      });

      /**
       * resetPassword API returns error in two ways
       * 1. For unidentified email, customerUserErrors is returned as part of forgotPasswordResult
       * 2. For Application related errors such as GraphQL errors, graphQLErrors is returned as part of forgotPasswordResult
       * 3. For any unexpected error, error is returned in forgotPasswordError
       */

      const hasErrors =
        (forgotPasswordResult.value.clientErrors &&
          forgotPasswordResult.value.clientErrors.length) ||
        (forgotPasswordResult.value.graphQLErrors &&
          forgotPasswordResult.value.graphQLErrors.length) ||
        forgotPasswordError.value.request;

      if (hasErrors) {
        isForgotPasswordError.value = true;
        errorMessage.value =
          "Sorry we couldn't process your request at this time. Please try again later";
      } else {
        successMessage.value =
          'If an email exists with those details, we will send you an email with a reset link';
      }
    };

    return {
      email,
      forgotPasswordLoading,
      isForgotPasswordError,
      errorMessage,
      successMessage,
      handleForgotPassword,
    };
  },
});
